import { render } from "./ReviewDetailWrapper.vue?vue&type=template&id=30b9f5ec"
import script from "./ReviewDetailWrapper.vue?vue&type=script&lang=js"
export * from "./ReviewDetailWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__